import { useEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { setHeaderTitle, setHeaderAction, setActionBtnTitle } from 'features/ui/model/uiSlice';
import { PromoB2BDetail } from 'widgets/promoB2B/ui/PromoB2BDetail';

export const PromoB2BDetailPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Промо акция'));
    dispatch(setHeaderAction('edit'));
    dispatch(setActionBtnTitle('Изменить'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <PromoB2BDetail />;
};
